import React, { useState } from 'react'

interface TooltipProps {
  content: React.ReactNode
  children: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  const [showTooltip, setShowTooltip] = useState(false)

  const handleMouseEnter = () => {
    setShowTooltip(true)
  }

  const handleMouseLeave = () => {
    setShowTooltip(false)
  }

  return (
    <div className="relative inline-block">
      <div
        className="hover:cursor-pointer w-full h-full"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {showTooltip && (
        <div className="absolute top-0 left-0 mt-10 p-2 w-fit z-[99999] bg-gray-800 text-white rounded-md text-xs text-nowrap">
          {content}
        </div>
      )}
    </div>
  )
}

export default Tooltip
